import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-emotion-sad-line text-4xl"></i>
      </span>
      <h1 className="mt-6 text-5xl font-bold text-foreground-950">404</h1>
      <p className="mt-3 text-lg font-medium text-foreground-700">页面走丢了</p>
      <p className="mt-2 max-w-md text-sm text-foreground-500">
        你访问的页面不存在或链接有误，返回首页继续浏览天堂影视的精彩内容吧。
      </p>
      <Link
        to="/"
        className="mt-6 flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
      >
        <i className="ri-home-line"></i>
        返回首页
      </Link>
    </div>
  );
}